var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83337 0.691666V2.375C13.4917 2.825 16.0834 6.15 15.6334 9.80833C15.25 12.8417 12.8667 15.25 9.83337 15.6083V17.275C14.4167 16.8167 17.75 12.75 17.2917 8.16667C16.9167 4.20833 13.775 1.08333 9.83337 0.691666ZM8.16671 0.716666C6.54171 0.874999 4.99171 1.5 3.72504 2.55L4.91671 3.78333C5.85004 3.03333 6.97504 2.55 8.16671 2.38333V0.716666ZM2.55004 3.725C1.50809 4.98945 0.866876 6.5359 0.708374 8.16667H2.37504C2.53337 6.98333 3.00004 5.85833 3.74171 4.91667L2.55004 3.725ZM0.716707 9.83333C0.883374 11.4667 1.52504 13.0083 2.55837 14.275L3.74171 13.0833C3.00582 12.1413 2.53667 11.0188 2.38337 9.83333H0.716707ZM4.91671 14.3083L3.72504 15.45C4.98736 16.5022 6.53277 17.1575 8.16671 17.3333V15.6667C6.98121 15.5134 5.85871 15.0442 4.91671 14.3083ZM9.41671 4.83333V9.20833L13.1667 11.4333L12.5417 12.4583L8.16671 9.83333V4.83333H9.41671Z",
    fill: "#11100E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.4b402d2836af8deddb959b28c6904931.svg";
export { ForwardRef as ReactComponent };